(function () {
  function initDogDadHeroDots() {
    document.querySelectorAll('[data-dogdad-hero-slider]').forEach(function (slider) {
      if (slider.dataset.mobileDotsReady === 'true') return;
      var slides = Array.from(slider.querySelectorAll('[data-dogdad-hero-slide]'));
      if (slides.length < 2) return;
      slider.dataset.mobileDotsReady = 'true';

      var dots = document.createElement('div');
      dots.className = 'dogdad-hero__mobile-dots';
      dots.setAttribute('aria-label', 'Hero slides');

      function getCurrentIndex() {
        var active = slides.findIndex(function (slide) { return slide.classList.contains('is-active'); });
        return active >= 0 ? active : 0;
      }

      function showSlide(index) {
        var current = (index + slides.length) % slides.length;
        slides.forEach(function (slide, slideIndex) {
          slide.classList.toggle('is-active', slideIndex === current);
        });
        slider.classList.toggle('dogdad-hero--campaign-active', slides[current] && slides[current].classList.contains('dogdad-hero__slide--campaign'));
        Array.from(dots.children).forEach(function (dot, dotIndex) {
          var isActive = dotIndex === current;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      }

      slides.forEach(function (_, index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'dogdad-hero__mobile-dot';
        dot.setAttribute('aria-label', 'Show slide ' + (index + 1));
        dot.addEventListener('click', function () { showSlide(index); });
        dots.appendChild(dot);
      });

      slider.appendChild(dots);

      var startX = 0;
      var startY = 0;
      var tracking = false;

      slider.addEventListener('touchstart', function (event) {
        if (!event.touches || event.touches.length !== 1) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        tracking = true;
      }, { passive: true });

      slider.addEventListener('touchend', function (event) {
        if (!tracking || !event.changedTouches || event.changedTouches.length !== 1) return;
        var deltaX = event.changedTouches[0].clientX - startX;
        var deltaY = event.changedTouches[0].clientY - startY;
        tracking = false;
        if (Math.abs(deltaX) < 45 || Math.abs(deltaX) < Math.abs(deltaY) * 1.25) return;
        showSlide(getCurrentIndex() + (deltaX < 0 ? 1 : -1));
      }, { passive: true });

      var prev = slider.querySelector('[data-dogdad-hero-prev]');
      var next = slider.querySelector('[data-dogdad-hero-next]');
      [prev, next].forEach(function (button) {
        if (!button) return;
        button.addEventListener('click', function () {
          window.setTimeout(function () { showSlide(getCurrentIndex()); }, 0);
        });
      });

      showSlide(getCurrentIndex());
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDogDadHeroDots);
  } else {
    initDogDadHeroDots();
  }
  document.addEventListener('shopify:section:load', initDogDadHeroDots);
})();